(function () {
  const bindMysteryBoxToProduct = false;

  function openCartDrawer() {
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.show !== 'function') return;
    document.addEventListener('cart-drawer:refreshed', function onRefreshed() {
      document.removeEventListener('cart-drawer:refreshed', onRefreshed);
      cartDrawer.show();
    }, { once: true });
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  async function checkMysteryProductInCart(productIds) {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      return cart.items.some((item) => productIds.includes(String(item.variant_id)));
    } catch (err) {
      console.error("Error checking cart:", err);
      return false;
    }
  }

  function onDOMContentLoaded() {
    const mysteryProductIds = [...document
      .querySelectorAll("[data-mystery-product]")].
      map(mp => mp.dataset.mysteryProductId);

    const mysteryProductPopup = document.querySelector("mystery-product-popup");

    if (mysteryProductPopup && mysteryProductIds.length) {
      document.addEventListener('click', async function (e) {
        if (e.target.closest('mystery-product-popup')) return;
        if (window.location.pathname.indexOf('/products/mystery-box') !== -1) return;
        if (e.target.closest('cart-drawer')) return;
        const btn = e.target.closest('button[type="submit"]');
        if (
          (!e.target.closest('product-form') &&
            !e.target.closest('buy-buttons')) ||
          !btn
        ) return;
        var productForm = btn.closest('product-form');
        if (productForm && productForm.dataset.productType === 'Bundle') return;

        if (!e.isTrusted) return;
        e.preventDefault();
        e.stopImmediatePropagation();

        const mysteryInCart = await checkMysteryProductInCart(mysteryProductIds);

        if (!mysteryInCart) {
          const form = btn.closest('form') || (btn.getAttribute('form') ? document.getElementById(btn.getAttribute('form')) : null);
          if (form) fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
          mysteryProductPopup.show(e.target);
        } else {
          var form = btn.closest('form');
          if (form && typeof form.requestSubmit === 'function') form.requestSubmit(btn);
          else if (form) form.submit();
        }

      });
    }
  }

  if (document.readyState !== 'loading') {
    onDOMContentLoaded();
  } else {
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
  }

  // the logic that automatically deletes mystery boxes from the cart
  /*
    window.addEventListener('aftersell-upcart:public-events:item-removed', (e) => {
      const item = e.detail.item;
      const itemIsMysteryBox = item.properties.hasOwnProperty('_mystery_box');
      if (itemIsMysteryBox) return;
      // document.querySelector('#CartPopup')?.classList.add('cart--rmb');
      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const currentMysteryBoxes = cart.items.filter(i => i.properties.hasOwnProperty('_mystery_box'));
        if (!currentMysteryBoxes.length) return;
        let mysteryBoxesToRemove = [];
        if (bindMysteryBoxToProduct) {
          currentMysteryBoxes.forEach(mb => {
            const attachedToProductId = parseInt(mb.properties['_with_product']);
            const productExists = !!cart.items.find(i => i.productId == attachedToProductId);
            if (!productExists) mysteryBoxesToRemove.push(mb);
          });
        } else {
          if (cart.items.length === 1) mysteryBoxesToRemove = currentMysteryBoxes;
        }
  
        if (!mysteryBoxesToRemove.length) {
          // document.querySelector('#CartPopup')?.classList.remove('cart--rmb');
          return;
        }
        let updates = {};
        mysteryBoxesToRemove.forEach(mbtr => updates[mbtr.key] = 0);
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            updates: updates
          }),
        })
        .then((response) => response.json())
        .then(() => {
          // document.querySelector('#CartPopup')?.classList.remove('cart--rmb');
          window.upcartRefreshCart();
        })
        .catch((err) => console.error('Error removing items from cart:', err));
      })
    });
  */
  window.addEventListener('aftersell-upcart:public-events:cart-loaded', (e) => {
    const cart = e.detail.cart;
    const cartPopup = document.querySelector('#CartPopup');
    if (!cartPopup) return;
    setTimeout(() => {
      const mysteryBoxes = cart.items.filter(i => i.properties.hasOwnProperty('_mystery_box'));
      mysteryBoxes.forEach(mysteryBox => {
        const mysteryBoxItem = cartPopup.querySelector(`[id="${mysteryBox.key}"]`);
        if (!mysteryBoxItem) return;
        console.log(mysteryBox);
        mysteryBoxItem.classList.add('upcart-product-mystery-box');
        const title = mysteryBoxItem.querySelector('.upcart-product-title');
        const links = mysteryBoxItem.querySelectorAll('a[href]');
        const productOption = mysteryBoxItem.querySelector('.upcart-item-option');
        const quantity = mysteryBoxItem.querySelector('input[type="number"]')?.closest('div');
        const quantityParent = quantity?.closest('.Stack__item');
        if (links.length) {
          links.forEach(link => {
            link.href = '#';
            link.dataset.noPointer = true;
          });
        }
        if (productOption) {
          productOption.remove();
        }
        // if (quantity) {
        //   quantity.remove();
        // }
        // Logic to add upcart-product-mystery-box-value - commented out
        /*
        if (
          quantityParent && 
          !quantityParent.querySelector('.upcart-product-mystery-box-value')
        ) {
          quantityParent.innerHTML = '';
          const valueEl = document.createElement('span');
          valueEl.classList.add('upcart-product-mystery-box-value');
          const currencyFormatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: Shopify.currency.active,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          });
          
          let value;
          // Priority 1: Use stored value amount (from metafield or calculated)
          if (mysteryBox.properties.hasOwnProperty('_value_amount')) {
            value = currencyFormatter.format(parseFloat(mysteryBox.properties['_value_amount']) / 100);
          } 
          // Priority 2: Fallback to calculating from multiplier
          else if (mysteryBox.properties.hasOwnProperty('_value_multiplier')) {
            const valueMultiplier = parseFloat(mysteryBox.properties['_value_multiplier']);
            value = currencyFormatter.format(Math.round(mysteryBox.originalPrice * valueMultiplier / 100));
          }
          
          if (value) {
            valueEl.innerHTML = window.mysteryBox.strings.value.replace('{{ price }}', value);
            quantityParent.append(valueEl);
          }
        }
        */
        if (title && mysteryBox.properties.hasOwnProperty('_cart_label')) {
          const existingLabel = mysteryBoxItem.querySelector('.upcart-product-label');
          if (existingLabel) {
            existingLabel.remove();
          }

          const cartLabelText = mysteryBox.properties['_cart_label'];
          const cartLabel = document.createElement('div');
          cartLabel.classList.add('upcart-product-label');
          cartLabel.innerHTML = cartLabelText;
          title.after(cartLabel);
        }
      });
    }, 100);
    setTimeout(() => {
      const productsWithLabels = {
        '50800139862296': 'MINI',
        '50800139895064': 'Premium ✨',
        '50800139927832': 'Exclusive'
      };

      cart.items.forEach(item => {
        let variantId = String(item.variant_id);
        if (item.key && item.key.includes(':')) {
          variantId = item.key.split(':')[0];
        }
        const labelText = productsWithLabels[variantId];

        if (labelText) {
          const productItem = cartPopup.querySelector(`[id="${item.key}"]`) ||
            cartPopup.querySelector(`[id*="${item.variant_id}"]`);
          if (!productItem) return;

          const title = productItem.querySelector('.upcart-product-title');

          if (title) {
            const existingLabel = productItem.querySelector('.upcart-product-label');
            if (existingLabel) {
              existingLabel.remove();
            }

            const cartLabelText = item.properties?._cart_label || labelText;
            const cartLabel = document.createElement('div');
            cartLabel.classList.add('upcart-product-label');
            cartLabel.innerHTML = cartLabelText;
            title.after(cartLabel);
          }
        }
      });
    }, 100);
  })

  class MysteryProductPopup extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector("button[data-close-button]");
      this.declineButton = this.querySelector("button[data-decline-button]");
      this.addToCarts = this.querySelectorAll('form[action="/cart/add"] button[type="submit"]');

      this.addToCarts?.forEach(atc => atc.addEventListener("click", this.addItems));
      [this.closeButton, this.declineButton].forEach(b => b.addEventListener("click", this.handlePopupAction));
      this.addEventListener('click', e => e.target === this && this.handlePopupAction());

    }

    show(triggeredBy) {
      this.triggeredBy = triggeredBy;
      this.classList.add('active');
    }

    hide() {
      this.classList.remove('active');
    }

    handlePopupAction = () => {
      this.hide();
      openCartDrawer();
    }

    addItems = (e) => {
      const submit = e.currentTarget;
      const form = submit.form || submit.closest('form');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const variantIdInput = form.querySelector('input[name="id"]');
      const mysteryProductId = variantIdInput ? variantIdInput.value : null;
      if (!mysteryProductId) return;
      const mysteryProductCard = submit.closest('.mystery-product-card');
      const masterProductId = (this.triggeredBy.closest('form') || document.querySelector(`#${this.triggeredBy.getAttribute('form')}`))['product-id'].value;
      const mysteryProductCartLabel = mysteryProductCard ? mysteryProductCard.dataset.mysteryProductCartLabel : false;
      const mysteryProductValueMultiplier = mysteryProductCard ? mysteryProductCard.dataset.mysteryProductValueMultiplier : false;
      const mysteryProductValueAmount = mysteryProductCard ? mysteryProductCard.dataset.mysteryProductValueAmount : false;

      this.classList.add('loading');
      submit.classList.add('loading');
      submit.disabled = true;

      let props = {
        '_mystery_box': "true",
        '_with_product': masterProductId
      };

      if (mysteryProductCartLabel) {
        Object.assign(props, {
          '_cart_label': mysteryProductCartLabel
        });
      }

      if (mysteryProductValueMultiplier) {
        Object.assign(props, {
          '_value_multiplier': String(mysteryProductValueMultiplier)
        });
      }

      if (mysteryProductValueAmount) {
        Object.assign(props, {
          '_value_amount': String(mysteryProductValueAmount)
        });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: mysteryProductId,
          quantity: 1,
          properties: props
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.handlePopupAction();

          this.classList.remove('loading');
          submit.classList.remove('loading');
          submit.disabled = false;
        })
        .catch((err) => console.error('Error adding item to cart:', err));

    }

  }

  if (!window.customElements.get("mystery-product-popup")) {
    window.customElements.define("mystery-product-popup", MysteryProductPopup);
  }
})();